<template lang="pug">
  div.dashboard
    div.container
      div.tabs-container
        div.tabs-item(@click="handleTabClick(tabNames.FLOWS)" :class="{ 'tabs-item-active': activeTabName === tabNames.FLOWS }") {{ $t('strings.flows') }}
        div.tabs-item(@click="handleTabClick(tabNames.BALANCESHEET)" :class="{ 'tabs-item-active': activeTabName === tabNames.BALANCESHEET }") {{ $t('strings.balance_sheet') }}
        div.tabs-item(@click="handleTabClick(tabNames.PENDINGEXPENSES)" :class="{ 'tabs-item-active': activeTabName === tabNames.PENDINGEXPENSES }") {{ $t('strings.pending_expenses') }}
        div.tabs-item(@click="handleTabClick(tabNames.PENDINGINCOME)" :class="{ 'tabs-item-active': activeTabName === tabNames.PENDINGINCOME }") {{ $t('strings.pending_income') }}
    Component(:is="currentTab")
</template>

<script>
const Flows = () => import('@/components/dashboard/Flows.vue')
const BalanceSheet = () => import('@/components/dashboard/BalanceSheet.vue')
const PendingExpenses = () => import('@/components/dashboard/PendingExpenses.vue')
const PendingIncome = () => import('@/components/dashboard/PendingIncome.vue')
const tabNames = {
  FLOWS: 'Flows',
  BALANCESHEET: 'BalanceSheet',
  PENDINGEXPENSES: 'PendingExpenses',
  PENDINGINCOME: 'PendingIngome'
}
export default {
  components: {
    Flows,
    BalanceSheet,
    PendingExpenses,
    PendingIncome
  },
  data: () => ({
    currentTab: Flows,
    activeTabName: 'Flows',
    tabNames,
    tabs: {
      [tabNames.FLOWS]: Flows,
      [tabNames.BALANCESHEET]: BalanceSheet,
      [tabNames.PENDINGEXPENSES]: PendingExpenses,
      [tabNames.PENDINGINCOME]: PendingIncome
    }
  }),
  created () {
    if (this.$route.params.isPrincipalPath != null) {
      this.currentTab = BalanceSheet
      this.activeTabName = 'BalanceSheet'
    }
  },
  methods: {
    handleTabClick (tabName) {
      this.activeTabName = tabName
      this.currentTab = this.tabs[tabName]
    }
  }
}
</script>
<style scoped lang="scss">
.dashboard {
  background-color: #fafafa;
  padding: 0 5rem 0 5rem;
}
.container {
  margin-bottom: 1rem;
}
.tabs-container {
  display: flex;
}
.tabs-item {
  padding: 0.5rem;
  margin-right: 1rem;
  text-align: left;
  cursor: pointer;
}
.tabs-item-active,
.tabs-item:hover {
  border-bottom: solid 0.3rem rgb(180, 3, 3);
  border-radius: 0.18rem;
}
</style>
